'use client';

import { FC } from 'react';

import { useDialogContext } from '../../../../hooks/use-dialog-context';
import { useProductCompare } from '../../../../hooks/use-product-compare';

import { ProductActionsList } from './product-actions-list';

export interface Props {
   productId?: string;
   productName?: string;
   feedbackUrl?: string;
   userMail?: string;
   tdsAnchor?: string;
   hasTeamdeskFeedbackFeatureToggle: boolean;
   hasProductCompareFeatureToggle: boolean;
   hasShareFeatureToggle: boolean;
}

export const ProductActions: FC<Props> = ({
   productId,
   productName,
   feedbackUrl,
   userMail,
   tdsAnchor,
   hasTeamdeskFeedbackFeatureToggle,
   hasProductCompareFeatureToggle,
   hasShareFeatureToggle
}) => {
   const { productItems, addProduct, removeProduct } = useProductCompare();
   const { dispatch } = useDialogContext();

   const compare = productId ? productItems.some((item) => item.id === productId) : false;

   const onCheckTds = () => {
      if (!tdsAnchor) return;

      window.dispatchEvent(new CustomEvent('onCheckTds'));

      document.getElementById(tdsAnchor)?.scrollIntoView({ behavior: 'smooth' });
   };

   const onShare = () => {
      if (dispatch) dispatch({ type: 'open_dialog', value: { dialogType: 'share-page' } });
   };

   const onFeedback = () => {
      if (!feedbackUrl) return;
      let teamdeskFeedbackUrl = feedbackUrl;
      if (userMail) {
         teamdeskFeedbackUrl += userMail;
      }
      window.open(teamdeskFeedbackUrl, '_blank');
   };

   const onCompare = () => {
      if (!productId) return;

      if (!compare) {
         addProduct(productId, productName ?? '');
      } else {
         removeProduct(productId);
      }
   };

   return (
      <ProductActionsList
         compare={compare}
         compareDisabled={productItems.length >= 5 && !compare}
         showCheckTds={!!tdsAnchor}
         showFeedback={!!feedbackUrl && hasTeamdeskFeedbackFeatureToggle}
         showCompare={hasProductCompareFeatureToggle}
         showShare={hasShareFeatureToggle}
         onCheckTds={onCheckTds}
         onShare={onShare}
         onFeedback={onFeedback}
         onCompare={onCompare}
      />
   );
};
